export default "__VITE_ASSET__Dy7NSX1p__"